import type {
  Diagnostic,
  RuleEvaluationContext,
  ValidationContext,
} from './types';
import { computeResolvedSubroutines } from './util/computeResolvedSubroutines';
import { runValidation } from './util/runValidation';

// Public surface: primary function + types
export * from './types';
export { runCommonRoutineRules } from './rules/commonRules';
export type { StepLike } from './rules/commonRules';
export { getMissingLocateSkillConfig } from './util/locateSkill';
export type { MissingLocateSkillConfig } from './util/locateSkill';

export function precheckForExecution(
  routine: unknown,
  options: { ctx?: ValidationContext } = {},
): { ok: true } | { ok: false; errors: Diagnostic[] } {
  const ctx: ValidationContext = options.ctx ?? {};

  const withRaw: RuleEvaluationContext = { ...ctx, rawRoutine: routine };

  const ruleCtx =
    ctx.subroutines && ctx.subroutines.size > 0
      ? {
          ...withRaw,
          resolvedSubroutines: computeResolvedSubroutines(ctx.subroutines, ctx),
        }
      : withRaw;

  return runValidation(routine, ruleCtx);
}
